var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { CalendarProvider } from '@gopeerproject/ui-kit';
import moment from 'moment-timezone';
import React, { useEffect, useState } from 'react';
const CalendarDropdownContext = React.createContext(
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
{});
export const useCalendarDropdownContext = () => React.useContext(CalendarDropdownContext);
export const CalendarDropdownProvider = (_a) => {
    var { children, onChange, mutable } = _a, props = __rest(_a, ["children", "onChange", "mutable"]);
    const [from, setFrom] = useState(props.from);
    const [to, setTo] = useState(props.to);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        if (onChange)
            onChange({ from, to });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [from, to]);
    useEffect(() => {
        if (mutable)
            setRange({ from: props.from, to: props.to });
    }, [props.from, props.to, mutable]);
    const setRange = ({ from, to }) => {
        if (from && to && moment(from).isAfter(to, 'day')) {
            setFrom(moment(to).toISOString());
            setTo(moment(from).toISOString());
        }
        else {
            setFrom(from && moment(from).toISOString());
            setTo(to && moment(to).toISOString());
        }
    };
    return (React.createElement(CalendarDropdownContext.Provider, { value: {
            from: from,
            to: to,
            setFrom: (from) => {
                setRange({ to, from });
            },
            setTo: (to) => {
                setRange({ to, from });
            },
            setRange,
            isOpen,
            setIsOpen
        } },
        React.createElement(CalendarProvider, null, children)));
};
//# sourceMappingURL=index.js.map